import React, {Component} from 'react'
import { Switch, Route } from 'react-router-dom'
import ReportsList from '../../components/Report/ReportsList'
import WorkProgress from '../../components/Report/WorkProgress'
import Defectiveness from '../../components/Report/Defectiveness'
import CompletionForecast from '../../components/Report/CompletionForecast'
import DefectivenessTrend from '../../components/Report/DefectivenessTrend'
import WelderBenchmark from '../../components/Report/WelderBenchmark'
import InspectionBacklog from '../../components/Report/InspectionBacklog'
import SectionProgress from '../../components/Report/SectionProgress'
import WpsUsage from '../../components/Report/WpsUsage'
import RepairAnalysis from '../../components/Report/RepairAnalysis'
import DailyBurnRate from '../../components/Report/DailyBurnRate'
import WeldLeadTime from '../../components/Report/WeldLeadTime'
import GroupingSavings from '../../components/Report/GroupingSavings'

export default class Reports extends Component {

  render() {
    return (
      <div className="animated fadeIn">
        <Switch>
          <Route exact path="/reports" component={ReportsList}/>
          <Route exact path="/reports/work-progress" component={WorkProgress}/>
          <Route exact path="/reports/project-defectiveness" component={Defectiveness}/>
          <Route exact path="/reports/welder-defectiveness" component={Defectiveness}/>
          <Route exact path="/reports/completion-forecast" component={CompletionForecast}/>
          <Route exact path="/reports/defectiveness-trend" component={DefectivenessTrend}/>
          <Route exact path="/reports/welder-benchmark" component={WelderBenchmark}/>
          <Route exact path="/reports/inspection-backlog" component={InspectionBacklog}/>
          <Route exact path="/reports/section-progress" component={SectionProgress}/>
          <Route exact path="/reports/wps-usage" component={WpsUsage}/>
          <Route exact path="/reports/repair-analysis" component={RepairAnalysis}/>
          <Route exact path="/reports/daily-burn-rate" component={DailyBurnRate}/>
          <Route exact path="/reports/weld-lead-time" component={WeldLeadTime}/>
          <Route exact path="/reports/grouping-savings" component={GroupingSavings}/>
        </Switch>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Reports/Reports.js